import { get } from "lodash-es";
import { useAssetContext } from "../context/assetContext";
import { Asset } from "../models/Asset";
import { getAssets } from "../repositorie/MESF-frontend-Repositorie";

export const useSearchAssets = (setError: (err: string) => void) => {
	const {
		actions: { setAllAssets, setAreasList },
	} = useAssetContext();

	const searchAssets = () => {
		getAssets().then(async (res) => {
			if (res.ok) {
				const rows = get(res, "data.tables[0].rows", []);
				const areas: Asset[] = await rows.filter(
					(asset: Asset) => asset.CanBeDefaultAsset,
				);
				setAllAssets(rows);
				setAreasList(areas);
			} else setError(res.message);
		});
	};
	return { searchAssets };
};
